import { inject, Injectable } from '@angular/core';
import { UserIndexedDbDictionaryRepository } from '../repositories/user-indexed-db-dictionary.repository';
import { IndexedDbDataAccess } from '@softline/core';
import { LastUsedList } from './last-used';
import { SOFTLINE_NAME_LAST_USED_OBJECT_STORE } from '../user.indexed-db';

@Injectable({providedIn: 'root'})
export class LastUsedRepository<T> extends UserIndexedDbDictionaryRepository<LastUsedList<T>> {

  constructor() {
    super(inject(IndexedDbDataAccess), SOFTLINE_NAME_LAST_USED_OBJECT_STORE);
  }

  protected override getKey(item: LastUsedList<T>): string {
    return item.key;
  }
}
